import React from "react";

const Navigation = ({
  steps,
  navigation,
  index,
  formData,
  submit,
  proceed,
  enrollmentFeeEnabled,
  acceptedEnrollmentFee,
}) => {
  const isLastStep = steps.length === index + 1;
  const hasPreviousButton = index > 0;
  const hasNextButton = steps.length > 1 && !isLastStep;
  const hasSubmitButton = steps.length === 1 || isLastStep;

  return (
    <div className="row g-2">
      {hasPreviousButton ? (
        <div className="col-md-4 offset-md-2 col-6">
          <button
            className="submit-button click-enroll-previous"
            onClick={navigation.previous}
          >
            PREVIOUS
          </button>
        </div>
      ) : (
        ""
      )}
      {hasNextButton ? (
        <div
          className={
            hasPreviousButton || hasSubmitButton
              ? "col-md-4 col-6"
              : "col-md-4 offset-md-4 col-12"
          }
        >
          <button
            type="submit"
            disabled={!proceed}
            className={
              proceed
                ? "submit-button click-enroll-next"
                : "submit-button disabled"
            }
          >
            NEXT
          </button>
        </div>
      ) : (
        ""
      )}
      {hasSubmitButton ? (
        <div
          className={
            hasPreviousButton || hasNextButton
              ? "col-md-4 col-6"
              : "col-md-4 offset-md-4 col-12"
          }
        >
          <button
            type="button"
            disabled={
              !proceed || (enrollmentFeeEnabled && !acceptedEnrollmentFee)
            }
            className={
              enrollmentFeeEnabled && !acceptedEnrollmentFee
                ? "submit-button disabled"
                : proceed
                  ? "submit-button click-enroll-submit"
                  : "submit-button disabled"
            }
            onClick={() => {
              submit(formData);
            }}
          >
            SUBMIT
          </button>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default Navigation;
